
import React, { createContext, useContext, useState } from 'react';
import { ProgramAIData } from '@/hooks/program/types';

interface SocialContextProps {
  isGenerating: boolean;
  setIsGenerating: (isGenerating: boolean) => void;
}

const SocialContext = createContext<SocialContextProps>({
  isGenerating: false,
  setIsGenerating: () => {},
});

export const SocialProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isGenerating, setIsGenerating] = useState(false);

  return (
    <SocialContext.Provider value={{ isGenerating, setIsGenerating }}>
      {children}
    </SocialContext.Provider>
  );
};

export const useSocial = () => useContext(SocialContext);
